export default {
    CARD_WIDTH: 390,
    IMAGE_HEIGHT: 188,
    WRITER_AVATAR_IMAGE_HEIGHT: 40,
    WRITER_AVATAR_IMAGE_WIDTH: 40
};
